import Vue from 'vue'
import moment from 'moment'

window.filters = {};

Vue.filter('commaFormat', function (value) {
    if (value) {
        return value.toString().replace(/^(-?\d+?)((?:\d{3})+)(?=\.\d+$|$)/, function (all, pre, groupOf3Digital) {
            return pre + groupOf3Digital.replace(/\d{3}/g, ',$&');
        });
    } else {
        return value;
    }
});

Vue.filter('limit', function (arr, length, include) {
    if (include) {
        length++;
    }

    if (arr && arr.length) {
        if (length == -1) {
            return arr;
        }
        if (length > arr.length) {
            return arr;
        }
        return arr.slice(0, length);
    }

    return null;
});

Vue.filter('range', function (arr, start, end) {
    if (arr && arr.length) {
        return arr.slice(start, end);
    }

    return null;
});

function padLeft(n, width, z) {
    z = z || '0';
    n = n + '';
    return n.length >= width ? n : new Array(width - n.length + 1).join(z) + n;
}
window.filters.padLeft = padLeft;

Vue.filter('orderid', function (value) {
    if (value && value.OrderSN) {
        return value.OrderSN;
    }
    if (value && value.CreateTime && value.OrderID) {
        return moment(value.CreateTime).format('YYYYMMDD') + padLeft(value.OrderID, 6);
    } else {
        return value;
    }
});

Vue.filter('padLeft', function (value, n) {
    return padLeft(value, n);
});

function dateFormat(value) {
    if(!value) return '';
    return moment(value).format("YYYY/MM/DD");
}
window.filters.dateFormat = dateFormat;

Vue.filter('dateFormat', dateFormat);

function dateTimeFormat(value) {
    if (!value) return '';
    return moment(value).format("YYYY/MM/DD HH:mm");
}
window.filters.dateTimeFormat = dateTimeFormat;

Vue.filter('dateTimeFormat', dateTimeFormat);

function timeFormat(value) {
    if (!value) return '';
    return moment(value).format("HH:mm:ss");
}
window.filters.timeFormat = timeFormat;

Vue.filter('timeFormat', timeFormat);

window.filters.imageCDN = function (value) {
    if (value) {
        if (value.indexOf('http') == 0) {
            return value;
        } else {
            return config.imageHost + value;
        }
    }
    return value;
}
Vue.filter('imageCDN', window.filters.imageCDN);